import React from 'react';
import { Link } from '@tanstack/react-router';
import { DiscovrLogo } from '../../design-system/components/discovr-logo';

/**
 * Minimal sidebar legal links — Privacy Policy · Terms.
 * Rendered at the bottom of AppSidebar so users can access legal pages
 * without leaving the dashboard.
 */
export function AppFooterLinks() {
  return (
    <div className="flex items-center justify-center gap-3 px-3 pb-3 pt-1">
      <Link
        to="/privacy-policy"
        className="text-[10px] text-muted-foreground transition-colors hover:text-muted-foreground"
      >
        Privacy
      </Link>
      <span className="text-[10px] text-muted-foreground">·</span>
      <Link
        to="/terms"
        className="text-[10px] text-muted-foreground transition-colors hover:text-muted-foreground"
      >
        Terms
      </Link>
    </div>
  );
}

/**
 * Minimal app footer — used on public/legal pages (Privacy Policy, Terms,
 * Login, Forgot Password, etc.). Dashboard pages do not use a footer.
 *
 * Pattern: Vercel / Linear / Stripe. Logo left, copyright + legal links right.
 * No marketing columns, no placeholder links.
 */
export function AppFooter() {
  return (
    <footer className="border-t border-border bg-background">
      <div className="mx-auto flex max-w-5xl flex-col items-center justify-between gap-4 p-6 sm:flex-row">
        {/* Brand */}
        <div className="flex items-center gap-2 text-foreground">
          <DiscovrLogo size={20} />
        </div>

        {/* Copyright + legal links */}
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-caption-regular text-muted-foreground sm:justify-end">
          <span>© 2026 Discovr, Inc.</span>
          <span className="hidden sm:inline text-muted-foreground">·</span>
          <Link
            to="/privacy-policy"
            className="transition-colors hover:text-foreground"
          >
            Privacy Policy
          </Link>
          <span className="text-muted-foreground">·</span>
          <Link
            to="/terms"
            className="transition-colors hover:text-foreground"
          >
            Terms of Service
          </Link>
          <span className="text-muted-foreground">·</span>
          <a
            href="mailto:support@getdiscovr.ai"
            className="transition-colors hover:text-foreground"
          >
            support@getdiscovr.ai
          </a>
        </div>
      </div>
    </footer>
  );
}
